// Packages
import React from "react";
import { isEmpty } from "lodash";

// Components
import { Box, CircularProgress } from "@mui/material";

const PendingChildren = ({
  isLoading,
  list,
  description
}) => {

  return (
    <>
      {
        isLoading ? (
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <CircularProgress />
          </Box>
        ) : isEmpty(list) ? (
          <Box>{description}</Box>
        ) : <></>
      }
    </>
  )
};

export default PendingChildren;